// needed for search results scrollIntoView
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
